// @flow

export { default } from './NotFound'
export * from './NotFound'
